function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .5)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "currentColor",
  strokeWidth: 1.2,
  cx: 8,
  cy: 8,
  r: 6.4
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.528 5.087)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 0.992,
  y: 5.174,
  width: 1.2,
  height: 1.2,
  rx: 0.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.603 3.958c-.04-.483.083-.727.28-.934.264-.275.904-.633 1.041-1.387C3.061.883 2.46 0 1.513 0 .858 0 .288.368 0 .908",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round"
})));

function SvgIco16HelpOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco16HelpOn);
export default __webpack_public_path__ + "static/media/ico_16_help_on.519c480f.svg";
export { ForwardRef as ReactComponent };